module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ParticipantMoreMenu__wrapper"
  }, [_c('i', {
    staticClass: "ParticipantMoreMenu__icon icon-ic_more",
    on: {
      "click": _vm.openMoreMenu
    }
  }), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "ParticipantMoreMenu__container"
  }, [_c('div', {
    directives: [{
      name: "prevent-parent-scroll",
      rawName: "v-prevent-parent-scroll"
    }],
    staticClass: "ParticipantMoreMenu__overlay",
    on: {
      "click": _vm.hideMoreMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ParticipantMoreMenu__dropdown",
    style: (_vm.style)
  }, _vm._l((_vm.actions), function(action) {
    return (!action.disabled) ? _c('div', {
      staticClass: "ParticipantMoreMenu__action",
      on: {
        "click": action.handler
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")]) : _vm._e()
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c2a1cd1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/participant-more-menu/participant-more-menu.vue
// module id = 444
// module chunks = 1